import type { ReactNode } from 'react';

import { closeDropdownFromElementWithin } from 'components/Dropdown/closeDropdownFromElementWithin';

import { DropdownMenuItemLi } from './DropdownMenuItem.styled';

type Props = {
  children: ReactNode;
  mobileOnly?: boolean;
  qaId?: string;
};

export function DropdownMenuItem({ children, mobileOnly, qaId }: Props) {
  return (
    <DropdownMenuItemLi
      $mobileOnly={mobileOnly}
      data-qa-id={qaId}
      onClick={(event) =>
        closeDropdownFromElementWithin(event.target as HTMLElement)
      }
    >
      {children}
    </DropdownMenuItemLi>
  );
}
